import React, {useCallback, useState} from "react";
import * as dayjs from "dayjs";
import {useTranslation} from "@/langs/useTranslation";
import {getProfileConfigHistoryList, getProfileConfigList} from "@/apis/apiCollection";
import DataTable from "@/components/DataTable";
import {useHistory} from "react-router-dom";
import {IStatus} from "../constant";
import styles from './index.module.less'
import {ReactRender} from "@/components/ReactRender";
import DeviceModal, {InstallType} from "@/containers/ProfileConfig/History/DeviceModal";

export const InstallHistoryListDataTable = React.forwardRef(
  (
    {
      className,
      style,
      getSearchParams,
      children,
      onLoaded,
      onAction
    },
    ref
  ) => {
    const {t} = useTranslation();
    const history = useHistory();

    const [deviceModalOpen, setDeviceModalOpen] = useState(false)
    const [deviceModalType, setDeviceModalType] = useState(0)
    const [configHistoryId, setConfigHistoryId] = useState('')

    const statusName = {
      [IStatus.ENABLE]: t({defaultMessage: "已发布"}),
      [IStatus.DISABLE]: t({defaultMessage: "禁用"}),
      [IStatus.DRAFT]: t({defaultMessage: "草稿"})
    };

    const columns = [
      {
        data: "name",
        title: t({defaultMessage: "配置文件名称"}),
        searchable: true,
        orderable: true,
        name: "1"
      },
      {
        data: "osType",
        title: t({defaultMessage: "类型"}),
        orderable: false
      },
      {
        data: "version",
        orderable: false,
        title: t({defaultMessage: "最新版本"}),
        render: data => data || "-"
      },
      {
        data: "createUserName",
        orderable: true,
        title: t({defaultMessage: "创建人"}),
        name: "2"
      },
      // {
      //   data: "createdAt",
      //   orderable: true,
      //   title: t({defaultMessage: "最新更新时间"}),
      //   render: data => {
      //     return dayjs(Number(data)).format("YYYY-MM-DD HH:mm");
      //   },
      //   name: "3"
      // },
      {
        data: "effectedAt",
        orderable: true,
        title: t({defaultMessage: "生效时间"}),
        render: data => {
          if (data === "0") return "-";
          return dayjs(Number(data)).format("YYYY/MM/DD HH:mm");
        },
        name: "4"
      },
      {
        data: "installNum",
        orderable: false,
        title: t({defaultMessage: "安装设备数"}),
        className: "center",
        createdCell: (td, data, row) => {
          ReactRender(
            <div
              className={styles.devicesNumber}
              onClick={() => {
                setDeviceModalOpen(true)
                setConfigHistoryId(row.id)
                setDeviceModalType(InstallType.SUCCESS)
              }}
              data-disablerowclick
            >
              {data}
            </div>, td
          )
        }
      },
      {
        data: "waitInstallNum",
        orderable: false,
        title: t({defaultMessage: "待安装设备数"}),
        className: "center",
        createdCell: (td, data, row) => {
          ReactRender(
            <div
              className={styles.devicesNumber}
              onClick={() => {
                setDeviceModalOpen(true)
                setConfigHistoryId(row.id)
                setDeviceModalType(InstallType.PENDING)
              }}
              data-disablerowclick
            >
              {data}
            </div>, td
          )
        }
      },
      {
        data: "unableInstallNum",
        orderable: false,
        title: t({defaultMessage: "无法安装设备数"}),
        className: "center",
        createdCell: (td, data, row) => {
          ReactRender(
            <div
              className={styles.devicesNumber}
              onClick={() => {
                setDeviceModalOpen(true)
                setConfigHistoryId(row.id)
                setDeviceModalType(InstallType.FAILED)
              }}
              data-disablerowclick
            >
              {data}
            </div>, td
          )
        }
      },
    ];

    const ajax = (data, callback) => {
      let orderType;
      let orderWay;
      const order = data.order[0];
      if (order && data.columns[order.column]?.orderable) {
        orderType = data.columns[order.column]?.name;
        // orderType = order.column;
        orderWay = order.dir === "asc" ? 1 : 2;
      }
      return getProfileConfigHistoryList({
        orderWay,
        orderType,
        ...getSearchParams(),
        page: data.page,
        pageSize: data.pageSize
      }).then(res => {
        callback({
          data: res.configHistories,
          draw: data.draw,
          recordsFiltered: res.total,
          recordsTotal: res.total
        });
      });
    };

    const onRowClick = useCallback((e, row) => {
      if (row && row.id) {
        if (row.osType === "windows") history.push(`/profile-config/install-history-windows/${row.id}`);
        else history.push(`/profile-config/install-history/${row.id}`);
      }
    }, []);

    return (
      <>
        <DataTable
          ref={ref}
          ordering
          columns={columns}
          ajax={ajax}
          className={className}
          style={style}
          scrollable
          showCheckAll={false}
          onLoaded={onLoaded}
          onRowClick={onRowClick}
          defaultOrder={[]}
        >
          {children}
        </DataTable>
        <DeviceModal
          open={deviceModalOpen}
          onClose={() => setDeviceModalOpen(false)}
          type={deviceModalType}
          configHistoryId={configHistoryId}
        />
      </>
    );
  }
);
